<template>
  <div class="topic_list" >
    <div class="list_wrap">
      <List v-model="loading" :finished="finished" @load="loadMore" finished-text="It's the end~"> 
        <div class="noissue_item" v-for="(item,index) in list" :key="index"  @click="LinkToHotDetails(item.id)">
          <img v-if="item.logoUrl" :src="item.logoUrl"  v-load="'oPic'" >
          <img v-else src="https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=2054454227,1114685042&fm=26&gp=0.jpg" >
          <div class="noissue_info">
            <div class="info_title">#{{item.title||'话题名称'}}#</div>
            <div class="info_brief">{{item.summary}}</div>
            <div class="info_count">
              <span>阅读数：{{wCount(item.viewCount)}}</span>
              <span>讨论数：{{wCount(item.talkCount)}}</span>
            </div>
            <div class="info_user">发起人：{{item.publisherName}}</div>
          </div>
          <div class="like_btn add_like" v-if="!item.isFollow"  @click.stop="addLike(item.id)">关注</div>
          <div class="like_btn " v-else  @click.stop="cancelLike(item.id)">已关注</div>
        </div>
        <div slot="loading" class="f-tac loading">
          <img src="@assets/img/new/icon-loading.png" />
          loading...
        </div>
        <div slot="finished" class="f-tac loading">It's the end~</div>
      </List>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import { List } from "vant";
import { mapGetters, mapActions } from "vuex";
export default {  
  name: "topic-list",
  data() {
    return {
      loading: false,   //话题加载状态
      finished: false,  //话题是否完成状态
      list: [],         //话题的列表
      pageIndex: 0,
      pageSize:20,
      queryThemeView:{},
    };
  },
  components: { List },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId:"getExhibitionId"
    }),
  },
  created() {
  },
  methods: {
    ...mapActions({
      LinkToHotDetails:'linkTo/LinkToHotDetails',
      followerTopic:'follower/followerTopic',
      delFollowerTopic:'follower/delFollowerTopic'
    }),
    wCount(value) {
      //过万处理
      let num = value;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 100) / 100 + "w";
      } else {
        num = value;
      }
      return num;
    },
    getList(){
      let query=gql`
      query queryThemeView($query:QueryInput!,$memberId:Guid!){
        queryThemeView(query:$query){
          hasNextPage
          indexFrom
          pageIndex
          pageSize
          items{
            theme{
              id
              title
              talkCount
              viewCount
              publisherName
              isFollow(memberId:$memberId)
              logoUrl
            }
          }
        }
      }`
      let where={
        "Equal":{
          "n":"memberId",
          "v":this.userInfo.inMember.memberId
        },
        "EqualB":{
          "n":"isDeleted",
          "v":0
        }
      }
      let order=[
        {
          "N":"createAt",
          "v":0
        }
      ]
      let opt={
        page:this.pageIndex,
        size:this.pageSize,
        where:JSON.stringify(where),
        order:JSON.stringify(order)
      }
      this.$apollo.addSmartQuery("queryThemeView",{ 
        query:query,
        variables:{
         query:opt,
         memberId:this.userInfo.inMember.memberId
        },
        fetchPolicy: 'network-only',    //清理缓存
        result(data){
          this.finished = true;
          console.log(res);
          let res=JSON.parse(JSON.stringify(data.data.queryThemeView));
          // let res=data.data.queryProduct;
          console.log('话题访问用户',res);
          let items=[]
          if(res&&res.items.length){
            res.items.forEach(el => {
              items.push(el.theme);
            });
          }
          if(items.length){
            items.forEach(e=>{
              if(e.banners&&e.banners.indexOf('[')!=-1){
              let banArr=JSON.parse(e.banners);
              e.banners=banArr[0];
            }
              let str=moment(e.startTime).format("MM/DD HH:mm");
              str+='~'+moment(e.endTime).format("MM/DD HH:mm");
              e.dateTime=str;
            })
          }
          if(this.pageIndex==1){
            this.list=items
          }else{
            this.list=[...new Set([...this.list,...items])];
          }
          this.loading=false;
          if (!res.hasNextPage) {
            this.finished = true;
          }
        },
        error(err){
          this.loading=false;
          this.finished = true;
          console.log('err',err)
        }
      })
    },
    //
    loadMore(){
      if(this.finished) return;
      this.pageIndex+=1;
      this.getList();
    },
    //取消关注
    async cancelLike(id){
      let opt={
        themeId:id,
        memberId:this.userInfo.inMember.memberId
      }
      let res= await this.delFollowerTopic(opt);
      if(res&&res.result){
        this.list.map(c=>{
          if(id === c.id){
            c.isFollow = false;
          }
        })
        this.$toast.success("取消关注");
      }else{
        this.$toast.fail('取消失败')
      }
    },
    //关注
    async addLike(id){
      let user={
        name:this.userInfo.name,
        nickName:this.userInfo.nickName,
        avatarUrl:this.userInfo.avatarUrl,
        jobTitle:this.userInfo.jobTitle
      }
      let opt={
        themeId:id,
        memberId:this.userInfo.inMember.memberId,
        userInfo:JSON.stringify(user)
      };
      let res= await this.followerTopic(opt);
      if(res.result){
        this.$toast.success('已关注');
        this.list.map(c=>{
          if(id === c.id){
            c.isFollow = true;
          }
        })
      }else{
        this.$toast.fail("关注失败");
      }
    }
  }
};
</script>

<style scoped lang="scss">
//展品列表
.topic_list{
  padding: 0.3rem 0.3rem 0;
  .list_wrap{
    .noissue_item{
        height: 2rem;
        box-sizing: border-box;
        padding: 0.2rem;
        background-color: #fff;
        border-radius: 0.05rem;
        display: flex;
        margin-top: 0.3rem;
        position: relative;
        .like_btn{
          position: absolute;
          bottom: 0.2rem;
          right: 0.2rem;
          height: 0.48rem;
          width: 1.1rem;
          border: solid 1px #ff5c00;
          border-radius: 0.26rem;
          color: #ff5c00;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: center;
          &.add_like{
            color: #fff;
            background: #ff5c00;
          }
        }
        &:first-child{
          margin-top:
           0;
        }
        img{
          flex-shrink: 0;
          width: 1.6rem;
          height: 1.6rem;
          border-radius: 0.05rem;
          display: block;
        }
        .noissue_info{
          width: calc(100% - 1.8rem);
          margin-left: 0.2rem;
          color: #666;
          font-size: 0.2rem;
          display: flex;
          flex-direction: column;
          div{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .info_title{
            font-size: 0.26rem;
            color: #333;

          }
          .info_brief{
            margin-top:0.05rem;
          }
          .info_count{
            margin-top: 0.2rem;
            span{
              margin-right: 0.3rem;
              &:last-child{
                margin-right: 0;
              }
            }
          }
          .info_count,.info_user{
            max-width: calc(100% - 1.1rem);
          }
          .info_user{
            margin-top: auto;
            color: #333;
          }
        }
      }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
